import PersonaSection from './PersonaSection';

export default PersonaSection;
